import mixpanel from 'mixpanel-browser';
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import { useUserStore } from '@/stores/user';

export function useMixpanelPageTracking() {
  const route = useRoute();
  const userStore = useUserStore();

  watch(
    () => route.fullPath,
    () => {
      try {
        const distinctId = userStore.user?.uuid ?? mixpanel.get_distinct_id();
        if (!distinctId) return;

        mixpanel.track('page_viewed', {
          distinct_id: distinctId,
          domain: window.location.hostname,
          slug: route.path
        });
      } catch {
        // mixpanel not initialised yet
      }
    },
    { immediate: true }
  );
}
